// extracted by mini-css-extract-plugin
module.exports = {"selectedUser":"selectOrder_selectedUser__1rbW3","selectedUserName":"selectOrder_selectedUserName__3y7GN","avatar":"selectOrder_avatar__1-T_6"};